import emptySplitApi from "../utils/rtk";
import { END_POINTS } from "../helpers";
import { CommonBody } from "../types/General";

type CommonResponseType = {
  statusCode: number;
  message: string;
  s3Location?: string;
};

export const catSubApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCatSubList: builder.query<
      CommonResponseType & { data: any },
      {
        type: number;
        categoryId?: string;
        tutorId?: string;
      }
    >({
      query: ({ type, categoryId, tutorId }) => {
        let url = `${END_POINTS.catSubList}?type=${type}${
          categoryId ? `&categoryId=${categoryId}` : ""
        }${tutorId ? `&tutorId=${tutorId}` : ""}`;
        return {
          url: url,
          method: "GET",
        };
      },
    }),
    getAllCategory: builder.query<
      CommonResponseType & { data: any },
      {
        page?: number;
        search?: string;
      }
    >({
      query: ({ page, search }) => {
        let url = `${END_POINTS.getAllCategory}?page=${page}&search=${search}`;

        return {
          url: url,
          method: "GET",
        };
      },
    }),
    getCategoryById: builder.query<
      CommonResponseType & { data: any },
      { id: any }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getCategoryById}/${id}/`,
        method: "GET",
      }),
    }),
    addCategory: builder.mutation<
      CommonResponseType & { data: CommonBody },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.addCategory}`,
        method: "POST",
        body,
      }),
    }),
    updateCategory: builder.mutation<
      CommonResponseType & { data: CommonBody },
      { id: string | undefined; body: CommonBody }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateCategory}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    deleteByIdCategory: builder.mutation<
      CommonResponseType & { data: any },
      { id: any }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteByIdCategory}/${id}/`,
        method: "DELETE",
      }),
    }),
    getAllSubject: builder.query<
      CommonResponseType & { data: any },
      {
        page?: number;
        search?: string;
        categoryId?: string;
      }
    >({
      query: ({ page, search, categoryId }) => {
        let url = `${END_POINTS.getAllSubject}?page=${page}&categoryId=${categoryId}&search=${search}`;

        return {
          url: url,
          method: "GET",
        };
      },
    }),
    getSubjectById: builder.query<
      CommonResponseType & { data: any },
      { id: any }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getSubjectById}/${id}/`,
        method: "GET",
      }),
    }),
    addSubject: builder.mutation<
      CommonResponseType & { data: CommonBody },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.addSubject}`,
        method: "POST",
        body,
      }),
    }),
    updateSubject: builder.mutation<
      CommonResponseType & { data: CommonBody },
      { id: string | undefined; body: CommonBody }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateSubject}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    deleteByIdSubject: builder.mutation<
      CommonResponseType & { data: any },
      { id: any }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteByIdSubject}/${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetCatSubListQuery,
  useLazyGetCatSubListQuery,
  useAddCategoryMutation,
  useAddSubjectMutation,
  useDeleteByIdCategoryMutation,
  useDeleteByIdSubjectMutation,
  useGetAllCategoryQuery,
  useGetAllSubjectQuery,
  useGetCategoryByIdQuery,
  useGetSubjectByIdQuery,
  useLazyGetAllCategoryQuery,
  useLazyGetAllSubjectQuery,
  useLazyGetCategoryByIdQuery,
  useLazyGetSubjectByIdQuery,
  useUpdateCategoryMutation,
  useUpdateSubjectMutation,
  // usePrefetch,
} = catSubApi;
